import { BaseParser, DATA_TYPE_DATA, TYPE_PSSESSION } from './baseExtractor.js';
import { ExtraConfigKey, NameExtraConfig } from '../commonPlotDefinitions.js'

const iconXMLFile = 'xml.png';

class XMLExtractor extends BaseParser {
  getArrayFromXMLElement(XMLElement) {
    if (typeof XMLElement === 'undefined') {
      return [];
    }
    const stringLine = XMLElement.firstChild.nodeValue;
    const split = stringLine.split(',');
    if (split.length === '1') {
      return [];
    }
    const newArray = Array(split.length).fill(0);
    for (let j = 0; j < newArray.length; j++) {
      newArray[j] = parseFloat(split[j]);
    }
    return newArray;
  }

  async _doParse(parent, fileName, data, report) {
    const returnValue = this.getNewReturnValue();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(data, 'text/xml');
    const curves = xmlDoc.getElementsByTagName('curves'); //Extract the curves tag
    if (curves.length === 0) {
        returnValue.lastError = `Error the file "${fileName}" does not contains curves`;
        return returnValue;
    }
    const curveList = curves[0].getElementsByTagName('curve');
    const measuTitle = xmlDoc.getElementsByTagName('title')[0].firstChild.nodeValue;

    returnValue.processedData = [];
    for (let j = 0; j < curveList.length; j++) {
        //Add all the curves
        const curve = curveList[j];
        let titlePlot = measuTitle;
        const name = curve.getElementsByTagName('name');
        let dataExtract = this.getDataFromFileName(titlePlot); //Extract data from the file name
        if (name.length !== 0) {
            const nameString = name[0].firstChild.nodeValue;
            titlePlot += ' - ' + nameString;
            const dataExtractCurve = this.getDataFromFileName(nameString);
            if (dataExtractCurve.concUnit !== '') {
                dataExtract = dataExtractCurve;
            }
        }
        const points = curve.getElementsByTagName('points');
        if (points.length === 0) {
            returnValue.warnings.push(`The file '${fileName}' curve ${j} does not have a 'points' tag defined`);
            continue;
        }
        const timeData = this.getArrayFromXMLElement(points[0].getElementsByTagName('time')[0]);
        if (timeData.length === 0) {
            returnValue.warnings.push(`The file '${fileName}' curve ${j} does not have a 'time' tag defined in points`);
        }
        const potentialData = this.getArrayFromXMLElement(points[0].getElementsByTagName('potential')[0]);
        if (potentialData.length === 0) {
            returnValue.warnings.push(`The file '${fileName}' curve ${j} does not have a 'potential' tag defined in points`);
        }
        const currentData = this.getArrayFromXMLElement(points[0].getElementsByTagName('i1')[0]);
        if (currentData.length === 0) {
            returnValue.warnings.push(`The file '${fileName}' curve ${j} does not have a 'current' tag defined in points`);
        }
        const newProcessedDatObjt = {
            title: titlePlot,
            group: dataExtract.group,
            concUnit: dataExtract.concUnit,
            time: timeData,
            potential: potentialData,
            current: currentData,
            fileName: fileName,
        };
        const i2 = this.getArrayFromXMLElement(points[0].getElementsByTagName('i2')[0]);
        if (i2.length > 0) {
            if(typeof report[ExtraConfigKey] === 'undefined')
                report[ExtraConfigKey] = {};
            //If there is a reverse current ther would be reverse in the title and current type in the fourth element
            report[ExtraConfigKey][NameExtraConfig.ReverseCurrentPresent] = true;
            newProcessedDatObjt.reverseCurrent = i2;
        }
        returnValue.processedData.push(newProcessedDatObjt);
    }
    returnValue.lastError = returnValue.processedData.length === 0 ? `File '${fileName}' is empty` : '';
    returnValue.dataType = DATA_TYPE_DATA;
    returnValue.type = TYPE_PSSESSION;
    returnValue.icon = iconXMLFile;
    returnValue.success = returnValue.processedData.length > 0;
    return returnValue;
  }
}

export{
  XMLExtractor,
};
